
define(
	'C3.PDPSerialLotFunctionality.Initial'
,   [
		'C3.PDPSerialLotFunctionality.Initial.View'
	]
,   function (
		InitialView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var pdpComponent = container.getComponent('PDP');
			var environment = container.getComponent("Environment");
			var layout = container.getComponent('Layout');
			
			 pdpComponent.addChildView('PDP.SerialLot.Functionality', function () {
			   var iteminfo = pdpComponent.getItemInfo()

			   var view = new InitialView({
			  	application: environment.application,
			  	layout : layout,
			  	iteminfo : iteminfo,
			  	container : container
			  });
			   container._serialLotInitialView = view;
			   return view;
			});

		}
	};
});
